import React, { PropsWithChildren } from "react";

import { Stack, TextField, styled, useTheme } from "@mui/material";

import { SearchIcon } from "../Icons";

interface SearchProps extends PropsWithChildren {
  borderRadius?: number;
  filter: string;
  paddingX?: number;
  paddingY?: number;
  placeholder?: string;
  hasBackground?: boolean;
  hasBorder?: boolean;
  footer?: React.ReactNode;
  setFilter: (value: string) => void;
}

export const Search = ({
  filter,
  placeholder,
  paddingX = 2,
  paddingY = 0.5,
  borderRadius = 6,
  hasBackground = true,
  hasBorder = true,
  setFilter,
  footer,
  children,
}: SearchProps) => {
  const {
    palette: { oscar },
    typography,
  } = useTheme();

  return (
    <Stack
      sx={() => ({
        backgroundColor: hasBackground
          ? oscar.light.surface.clear
          : "transparent",
        borderColor: oscar.light.borders.gray,
        borderRadius,
        borderStyle: "solid",
        borderWidth: hasBorder ? 1 : 0,
        width: "100%",
      })}
    >
      <Stack
        direction="row"
        flex={1}
        sx={() => ({
          alignItems: "center",
          gap: 1,
          paddingX,
          paddingY,
        })}
      >
        <Stack>
          <SearchIcon
            onClick={(e) => e.stopPropagation()}
            color={oscar.light.content.content1}
            height={16}
            width={16}
          />
        </Stack>
        <StyledTextInput
          variant="standard"
          sx={{
            width: "100%",
            "& .MuiInput-underline:before, & .MuiInput-underline:after": {
              border: "none !important",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              boarder: "none !important",
            },
            // Remove focus underline/shadow
            "& .MuiInput-underline.Mui-focused:after": {
              border: "none !important",
            },
            "& .MuiInputBase-root": {
              border: "none !important",
            },
          }}
          onClick={(e) => e.stopPropagation()}
          placeholder={placeholder}
          InputProps={{ disableUnderline: true }}
          inputProps={{ style: typography.inputR }}
          onChange={(e) => setFilter(e.target.value)}
          value={filter}
        />
        {children}
      </Stack>

      {footer}
    </Stack>
  );
};

const StyledTextInput = styled(TextField)(() => ({
  "& .MuiInputBase-root": {
    padding: 0,
    borderBottomWidth: `0 !important`,
  },
  "& .MuiInputBase-input": {
    fontSize: 14,
    lineHeight: 2,
  },
  padding: 0,
  "& ::before": {
    borderBottomWidth: `0 !important`,
  },
  "& ::after": {
    borderBottomWidth: `0 !important`,
  },
  "& ::focus": {
    borderBottomWidth: 0,
  },
  "& ::hover": {
    borderBottomWidth: 0,
  },
}));
